import { setAttribute } from "@sentry/react";

export const setSentryUrlAttribute = (url: string): void => {
  if (typeof window === "undefined") {
    return;
  }

  setAttribute("url", url);
};
